import Uris from 'src/services/Uris'
import formatUri from 'src/utils/formatUri'
import { IStudentWithPagination } from 'src/services/Student/interfaces'
import { getAllPosts, getPost, IPost, IPostWithPagination } from 'src/services/Post'
import { getStudents } from 'src/services/Student'
import { getCategories, ICategory } from '../services/Categories'
import useFetchData from './useFetchData'

export const useStudents = (params) => {
  const {
    data,
    error,
  } = useFetchData<IStudentWithPagination>({
    uri: Uris.admin.students.getAll,
    args: params,
    fetcher: () => getStudents(params),
  })
  return {
    data,
    error,
  }
}

export const usePosts = (params) => {
  Object.keys(params).forEach((key) => {
    if (Object.values(params)[0] === null) delete params[key]
  })

  const {
    data,
    error,
    isLoading,
  } = useFetchData<IPostWithPagination>({
    uri: Uris.admin.blog.posts,
    args: params,
    fetcher: () => getAllPosts(params),
  })
  return {
    data,
    error,
    isLoading,
  }
}

export const usePost = (slug: string) => {
  const {
    data,
    error,
  } = useFetchData<IPost>({
    uri: formatUri(Uris.admin.blog.post, slug),
    args: slug,
    enabled: !!slug,
    fetcher: () => getPost(slug),
  })
  return {
    data,
    error,
  }
}

export const useCategories = () => {
  const {
    data,
    error,
  } = useFetchData<ICategory[]>({
    uri: Uris.admin.blog.categories.getAll,
    fetcher: () => getCategories(),
  })
  return {
    data,
    error,
  }
}
